import { use, useRef } from "react";
import { getCookie } from "@litres/utils";
import clsx from "clsx";

import { getConfig } from "lib/get-config";
import { captureException } from "lib/logger";
import { ModalsContext } from "lib/modals/use-modals";

import css from "./upsell.module.scss";

// Upsell на localhost шумит корсами
const ENABLE_UPSELL_IFRAME = !import.meta.env.DEV;

export function Upsell() {
  const { art, trials } = getConfig();
  const { upsell, hideUpsell } = use(ModalsContext)!;
  const iframeRef = useRef<HTMLIFrameElement>(null);

  const url = new URL("/pages/upsale_in_or/", window.location.origin);
  url.searchParams.set("art", art.toString());
  const sid = getCookie("SID");
  if (sid) {
    url.searchParams.set("nextauth", sid);
  }
  const src = url.toString();

  function onIframeLoad() {
    try {
      const closeBtn =
        iframeRef.current?.contentDocument?.querySelector(".close-btn");
      if (!closeBtn) return;

      closeBtn.addEventListener("click", () => {
        hideUpsell();
      });
    } catch (error) {
      captureException(error as Error);
    }
  }

  if (!ENABLE_UPSELL_IFRAME || upsell.hasBeenShown || trials === 1) return null;

  return (
    <div
      className={clsx(css.root, upsell.isVisible && css.visible)}
      inert={!upsell.isVisible}
      onTransitionEnd={() => {
        if (!upsell.isVisible) {
          hideUpsell();
        }
      }}
    >
      <iframe
        ref={iframeRef}
        src={src}
        onLoad={onIframeLoad}
        loading="lazy"
        className={css.iframe}
        sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation-by-user-activation"
        referrerPolicy="no-referrer-when-downgrade"
        title="Upsell"
      />
    </div>
  );
}
